import { BookModel } from "../../../model/bookModels/book-model";

export class DraftModel {
    [key: string]: unknown;
    post?: IPostDraft;
    booklist?: IBooklistDraft;

    quote?: IQuoteDraft = new IQuoteDraft();
    review?: IReviewDraft = new IReviewDraft();
    history?: IHistoryDraft = new IHistoryDraft();
}
export interface IDraftItem {
    draftKey: string
};
export class IPostDraft implements IDraftItem {
    draftKey!: string;
    body?: string;
    title?: string;
    preview?: string;
    tags?: string[];
    attachedBooks?: BookModel[];
}

export class IReviewDraft implements IDraftItem {
    draftKey!: string;
    data: IReviewDraftTemp[] = [];
}

export interface IReviewDraftTemp {
    rate?: number;
    body?: string;
    bookId?: string;
    spoilerAlert?: boolean;

}

export class IQuoteDraft implements IDraftItem {
    draftKey!: string;
    data: IQuoteDraftTemp[] = [];
}

export class IQuoteDraftTemp {
    body?: string;
    bookId?: string;
    pageNumber?: number;
    imageSelected?: boolean;
}

export class IHistoryDraft implements IDraftItem {
    draftKey!: string;
    data: IHistoryDraftTemp[] = [];
}

export class IHistoryDraftTemp {
    body?: string;
    bookId?: string;
    pageNumber?: number;
}

export class IBooklistDraft implements IDraftItem {
    draftKey!: string;
    title?: string;
    books?: BookModel[];
    description?: string;
}

export const DRAFT_KEY = 'draft';